import { AppColor, AppColorContainer } from "../AppColorContainer";

/** This is the color container light mode implementation used by getAppColorContainer interface implementation for Word app*/
export class LightModeWordAppColorContainer implements AppColorContainer {

  darkLabelColor: AppColor = { value : "#212121" };

  mediumLabelColor: AppColor = { value : "#303030" };

  lightLabelColor: AppColor = { value : "#6e6e6e" };

  timestampLabelColor: AppColor = { value: "#11100f" };

  linkColor: AppColor = { value: "#2b579a" };

  defaultBackgroundColor: AppColor = { value: "#edebe9" };

  lightBackgroundColor: AppColor = { value: "#faf9f8" };

  darkBackgroundColor: AppColor = { value: "#cccccc" };

  primaryWidgetColor: AppColor = { value: "#2b579a" };

  primaryWidgetColorOnHover: AppColor = { value: "#245BBE" };

  primaryWidgetLabelColor: AppColor = { value: "#ffffff" };

  secondaryWidgetColor: AppColor = { value: "#FFFFFF" };

  secondaryWidgetColorOnHover: AppColor = { value: "#FFFFFF" };

  secondaryWidgetLabelColor: AppColor = { value: "#323130" };

  secondaryWidgetLabelColorOnHover: AppColor = { value: "#323130" };

  secondaryWidgetBorderColor: AppColor = { value: "#BEBBB8" };

  blackColor: AppColor = { value: "#000000" };

  whiteColor: AppColor = { value: "#ffffff" };

  wordBlue: AppColor = { value: "#2e6ac5" };

  keyboardFocusColor: AppColor = { value: "#605e5c" };

  lightBlue: AppColor = { value: "#0078d4" };

  tagBlue: AppColor = { value: "#2E6AC5" };

  bulletGray: AppColor = { value: "#D2D0CE" };

  progressBackground: AppColor = { value: "#D5D4D2" };

  popupBackground: AppColor = { value: "#2B579A" };

  transcribeIllustrationHeadsetInnerColor: AppColor = { value: "#605D5A" };

  transcribeIllustrationHeadsetOuterColor: AppColor = { value: "#33312D" };

  transcribeIllustrationHeadsetWireColor: AppColor = { value: "#3E8EED" };

  transcribeIllustrationCatLegsColor: AppColor = { value: "#72ACF1" };

  transcribeIllustrationCatBodyGradientStartColor: AppColor = { value: "#3395e5" };

  transcribeIllustrationCatBodyGradientEndColor: AppColor = { value: "#72ACF1" };

  transcribeIllustrationCatTailGradientStartColor: AppColor = { value: "#3395e5" };

  transcribeIllustrationCatTailGradientEndColor: AppColor = { value: "#72ACF1" };

  micWidgetBorderColor: AppColor = { value: "#2b579a" };

  // TODO: change color as per word
  charcoalColor: AppColor = { value: "#333333" };

  darkGrayColor: AppColor = {value: "#404040"};

  transcriptionIndicatorTextColor: AppColor  = {value: "#9E9E9E"};

  officeDesktopBackgroundColor: AppColor = {value: "#F0F0F0"};

  recordingIconRingsColor: AppColor = {value: "#BBCBE4"};

  listeningIconOuterColor: AppColor = {value: '#185ABD'};

  listeningIconMicColor: AppColor = {value: '#FFFFFF'};

  pauseIconOuterColor: AppColor = {value: '#FFFFFF'};

  pauseIconMicColor: AppColor = {value: '#185ABD'};

  oneDriveInfoTextColor: AppColor = {value: '#000000'};

  dropDownSelectionColor: AppColor = {value: '#0000001A'};

  dropDownHoverColor: AppColor = {value: '#F3F2F1'};

  private static instance: LightModeWordAppColorContainer | null = null;

  static GetInstance() {
    if (this.instance == null) this.instance = new LightModeWordAppColorContainer();

    return this.instance;
  }
}